<template>
    <Dialog header=""
            :visible.sync="displayModal"
            :style="{width: '25vw'}"
            :closable="false"
            :modal="true"
            @keyup.esc="close"
            @keyup.enter="yes">
        <div>{{ message || $t('areYouSure') }}</div>

        <template #footer>
            <Button :label="$t('yes')" icon="pi pi-check" @click="yes"/>
            <Button :label="$t('no')" icon="pi pi-times" @click="close" class="p-button-danger"/>
        </template>
    </Dialog>
</template>

<script>
    export default {
        model: {
            event: 'on-yes'
        },
        props: {
            displayModal: Boolean,
            message: String
        },
        methods: {
            yes() {
                this.$emit('on-yes');
                this.close();
            },
            close() {
                this.$emit('update:displayModal', false);
            }
        }
    }
</script>

<i18n lang="yaml" locale="en">
  areYouSure: "Are you sure?"
</i18n>

<i18n lang="yaml" locale="dk">
  areYouSure: "Er du sikker?"
</i18n>
